import React, { useEffect, useState } from 'react'

import { observer } from 'mobx-react-lite'
import { Instance, cast } from 'mobx-state-tree'

import { useStores, setPageTitle, Badge } from '@trivie/core'
import { UserBadges } from '@trivie/ui-mobile'

export const BadgesScreen = observer(() => {
  const { userStore, badgeStore } = useStores()
  const { user, setSplashNotifications } = userStore
  const { getBadgesForUser, badges } = badgeStore

  const [loadingBadges, setLoadingBadges] = useState(true)

  const loadBadges = () => {
    if (user) {
      setLoadingBadges(true)
      getBadgesForUser(user.id).then(() => {
        setLoadingBadges(false)
      })
    }
  }

  useEffect(() => {
    loadBadges()
    setPageTitle(`Profile - ${process.env.REACT_APP_SITE_TITLE}`)
  }, [])

  const goToBadge = (badge: Instance<typeof Badge>) => {
    setSplashNotifications(
      cast([
        {
          notification_type: 'badge',
          badge_icon_url: badge.icon_url,
          label: badge.label,
          description: badge.description,
          locked: !badge.awarded_at,
          hide_celebration: true,
        },
      ]),
    )
  }

  return <UserBadges goToBadge={goToBadge} loading={loadingBadges} badges={badges} />
})
